const content = {
  title: 'Katie Warren',
  subtitle: 'Psychotherapy & Counselling',
};

export default content;
